import * as React from "react";
import { useSearchParams } from "react-router-dom";
import AuthPageWrapper from "../components/auth-page-wrapper";
import RequestPasswordReset from "./request-password-reset";
import ResetPassword from "./reset-password";

/**
 * ====================================================================================================
 * PASSWORD RESET FLOW
 * ====================================================================================================
 *
 * The ForgotPassword component conditionally renders one of two password reset components
 * based on the presence of a token in the URL query parameters.
 *
 * The password reset process is split into two separate steps, each handled by a different component:
 *
 * 1. RequestPasswordReset
 *    - Displayed when no token is present in the URL
 *    - Collects the user's email address
 *    - Calls the API endpoint: POST /login/native/password-recovery
 *    - After successful submission, a verification email is sent to the user
 *
 * 2. ResetPassword
 *    - Displayed when a token is present in the URL e.g: /forgot-password?token=eyJhbG... (from email)
 *    - Collects new password
 *    - Calls the API endpoint: POST /login/native/password-reset (token is passed in the request body)
 *    - After successful submission, the user's password is reset and they can log in with the new password
 *
 * ====================================================================================================
 */

const ForgotPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  return (
    <AuthPageWrapper
      title="Forgot your password?"
      subtitle={
        token
          ? "Time to pick a shiny new password!"
          : "No worries! Let's help you get back into your account"
      }
    >
      {token ? <ResetPassword token={token} /> : <RequestPasswordReset />}
    </AuthPageWrapper>
  );
};

export default ForgotPassword;
